import './error.css';



const ErrorPage = () => {
    return (
			<div className='page-wrapper'>
				<h3 className='page-title'>404</h3>
				<h4 className='page-description'>Page not found</h4>
			</div>
		)
}

export default ErrorPage
